import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import routes from "../../../../constants/routes";
import createEventAPI from "../../../../api/createEventAPI";
import AuctionForm from "../../../commonComponents/AuctionForm";
import "react-toastify/dist/ReactToastify.css";

const RenderCreateAuctionForm = ({
  countriesList,
  stateList,
  setIsLoading,
  classes,
  fetchStateData,
  eventFormat,
}) => {
  const navigate = useNavigate();
  const isDutchAuction = eventFormat === "dutch_auction";
  const isJapaneseAuction = eventFormat === "japanese_auction";

  const [eventInfo, setEventInfo] = useState({
    auctionTitle: "",
    referenceNumber: "",
    description: "",
    eventType: "",
    bidType: "",
    testProject: "false",
    streetOne: "",
    streetTwo: "",
    country: "",
    province: "",
    city: "",
    postalCode: "",
    eventImage: "",
    auctionCatalogue: "",
    visibility: "",
  });

  const getEventFormatEnum = (format) => {
    switch (format) {
      case "english_auction":
        return "ENGLISH_AUCTION";
      case "dutch_auction":
        return "DUTCH_AUCTION";
      case "japanese_auction":
        return "JAPANESE_AUCTION";
      default:
        return "ENGLISH_AUCTION";
    }
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      setIsLoading(true);
      
      const payload = { ...eventInfo };
      payload.testProject = payload.testProject === "true";
      payload.eventFormat = getEventFormatEnum(eventFormat);

      if (isJapaneseAuction || isDutchAuction) {
        delete payload.bidType;
      }

      const { data } = await createEventAPI(payload);
      if (data) {
        toast.success("Event Created Successfully!");
        setTimeout(() => {
          setIsLoading(false);
          navigate(routes.event, { state: { data: data } });
        }, 1500);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      if (error.response) {
        toast.error(error.response.data.error || "Something went wrong!");
      } else {
        toast.error("Network Error!");
      }
    }
  };

  return (
    <AuctionForm
      mode="create"
      eventInfo={eventInfo}
      setEventInfo={setEventInfo}
      countriesList={countriesList}
      stateList={stateList}
      fetchStateData={fetchStateData}
      setIsLoading={setIsLoading}
      eventFormat={eventFormat}
      onSubmit={handleSubmit}
      classes={classes}
    />
  );
};

export default RenderCreateAuctionForm;
